import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";
import { usePermissions } from "~/shared/context/PermissionContext";

import { announcementFilterFields } from "./fields";

const AnnouncementFilter = () => {
  const { t } = useTranslation();
  const { hasPermission } = usePermissions();

  const canSeeAllStatuses =
    hasPermission("announcements.setStatus") || hasPermission("announcements.edit");

  const fields = useMemo(
    () => announcementFilterFields(t, canSeeAllStatuses),
    [t, canSeeAllStatuses],
  );

  return <Filter.Root fields={fields} alwaysShow columns={6} />;
};

export default AnnouncementFilter;
